import React, { Component } from 'react';
import { Modal, message, Spin } from 'antd';
import { getMatchOption } from '../../shared/selectFn';
import format from '../../shared/format';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import UpdateUI from './UpdateUI';

const initialState = () => ({
    loading: false,
    visible: false,

    sponsorWritable: false,
    proCodeWritable: false,
    customerWritable: false,

    saveParams: {},
    investigation: {},

    baList: [],
    fileList: [],
    currencyList: [],
    belongingToUnitList: [],
    relationContractList: [],
    rateCanEdit: false,
});

class Update extends Component {
    state = initialState()

    show = (record) => {
        const {
            investigationId,
            isClinicalProject,
            investigationName,
            terminationReason,
            unitOfSigningId,
            belongingToUnit,
            unitOfBelongingId,
            investigationPauseReason
        } = record;
        const { signingUnitList } = this.props;
        this.setState({
            visible: true,
            saveParams: {
                investigationId,
                investigationName,
                terminationReason,
                isClinicalProject,
                jdeApplyIsInvestigationExists: 1,
                contractOrLetterIsSign: 1,
                signingUnit: unitOfSigningId,
                belongingToUnit: unitOfBelongingId,
                belongingToUnitName: belongingToUnit,
                investigationPauseReason:investigationPauseReason
            },
            belongingToUnitList: getMatchOption(signingUnitList, 'unitOfSigningId', unitOfSigningId).belongings || [],
        }, () => {
            const { saveParams } = this.state;
            const { investigationId, investigationName } = saveParams;
            this.queryInvFinishInfo(investigationId, () => this.loadFileList('CONTRACT'));
            this.loadInvestigation(investigationName);
            this.loadRelationContractList(investigationId);
            this.loadAllCurrencyExchangeRateList(); // 查询币种信息
        });
    }

    hide = () => {
        this.setState(initialState());
    }

    /**
     * 查询项目终止信息
     * @param {Number} investigationId 项目id
     * @param {Function} callback 回调
     */
    queryInvFinishInfo = (investigationId, callback) => {
        Fetch.post(API_URL.proContract.getInvTerminationApplyInfo, { investigationId })
            .then(res => {
                const { data: { invTerminationApplyId, terminationReason, fileList: terminationFileList } } = res;
                const { fileList, saveParams } = this.state;
                if (invTerminationApplyId) {
                    saveParams.terminationReason = terminationReason;
                    terminationFileList.forEach((item, index) => {
                        const { name, fileMateId, invTerminationApplyId } = item;
                        fileList.push({
                            name,
                            response: { fileMetaId: fileMateId },
                            uid: `${invTerminationApplyId}.${index}`,
                            deletable: false,
                        });
                    });
                }
                this.setState({
                    fileList,
                    saveParams,
                    invApplyFinish: !!invTerminationApplyId,
                }, () => {
                    callback && callback();
                });
            })
            .catch(error => console.log(error));
    }

    /**
     * 查询项目
     * @param {String} investigationName 项目名
     */
    loadInvestigation = (investigationName) => {
        Fetch.post(API_URL.investigation.queryInvestigationByName, { investigationName })
            .then(res => {
                const { saveParams } = this.state;
                const investigation = res.data[0] || {};
                const { natureOfContract } = saveParams;
                const { isClinicalProject, investigationSponsorId, investigationSponsor, investigationCode, lineOfBusiness, lineOfBusinessString } = investigation;
                saveParams.isClinicalProject = isClinicalProject != undefined ? isClinicalProject.toString() : undefined;
                saveParams.sponsorId = investigationSponsorId;
                saveParams.sponsorName = investigationSponsor;
                saveParams.customerProjectCode = investigationCode;
                saveParams.lineOfBusiness = lineOfBusiness;
                saveParams.lineOfBusinessString = lineOfBusinessString;
                this.setState({
                    saveParams,
                    investigation,
                    sponsorWritable: natureOfContract && natureOfContract !== 'FIRST_CONTRACT' ? !investigationSponsorId : false,
                    proCodeWritable: natureOfContract && natureOfContract !== 'FIRST_CONTRACT' ? !investigationCode : false,
                });
            })
            .catch(error => console.log(error));
    }

    /**
     * 查询文件
     * @param {String} uploadType 文件类型
     */
    loadFileList = (uploadType) => {
        const { saveParams: { jdeApplyId } } = this.state;
        Fetch.post(API_URL.contract.queryJdeApplyFileMetaById, {
            jdeApplyId,
            uploadType,
        }).then(res => {
            const { data } = res;
            const { fileList } = this.state;
            data.forEach((item, index) => {
                const { name, fileMateId } = item;
                fileList.push({
                    name,
                    response: { fileMetaId: fileMateId },
                    uid: index,
                });
            });
            this.setState({ fileList });
        }).catch(error => console.log(error));
    }

    /**
     * 查询关联合同
     */
    loadRelationContractList = () => {
        const { saveParams: { investigationId } } = this.state;
        if (investigationId) {
            Fetch.post(API_URL.contract.queryRelationJdeId, { investigationId })
                .then(res => {
                    this.setState({ relationContractList: res.data || [] });
                })
                .catch(error => console.log(error));
        } else {
            this.setState({ relationContractList: [] });
        }
    }

    /**
     * 查询汇率
     */
     loadAllCurrencyExchangeRateList = () => {
        Fetch.post(API_URL.contract.queryAllCurrencyExchangeRate)
            .then(res => {
                const { saveParams } = this.state;
                const { exchangeRate, currencyExchangeRateId } = getMatchOption(res.data, 'currencyName', '人民币');
                saveParams.exchangeRate = exchangeRate;
                saveParams.currencyExchangeRateId = currencyExchangeRateId;
                this.setState({
                    saveParams,
                    currencyList: res.data,
                });
            })
            .catch(error => console.log(error));
    }

    /**
     * 查询客户
     */
    queryCustomerCompanyBaList = () => {
        const { saveParams: { customerCompanyId } } = this.state;
        if (customerCompanyId) {
            Fetch.post(API_URL.contract.queryCustomerCompanyBaList, { customerCompanyId })
                .then(res => {
                    const { datas } = res;
                    const { saveParams } = this.state;
                    const baList = ((datas || [])[0] || {}).baList;
                    if ((baList || []).length === 1) {
                        const [{ customerCompanyBaId, employeeCode, userCompellation }] = baList;
                        saveParams.customerCompanyBaId = customerCompanyBaId;
                        saveParams.baName = userCompellation;
                        saveParams.baCode = employeeCode;
                    }
                    this.setState({ baList });
                })
                .catch(error => console.log(error));
        } else {
            this.setState({ baList: [] });
        }
    }

    submit = () => {
        const {
            saveParams,
            sponsorWritable,
            customerWritable,
            proCodeWritable,
            fileList,
            currencyList,
        } = this.state;
        const {
            natureOfContract,
            relationJdeId,
            sponsorId,
            baUserId,
            customerCompanyId,
            customerCompanyBaId,
            customerProjectCode,
            contractRelationSite,
            expectContractAmount,
            contractIsSpecifiesAmount,
            contractAmount,
            taxationFee,
            rate,
            actualExpenseFee,
            actualFee,
            contractStartDate,
            contractEndDate,
            lineOfBusiness,
            belongingToUnit,
            signingUnit,
            exchangeRate, //汇率
            currencyExchangeRateId,
        } = saveParams;
        // 关联JDE 是否必填 需求【REQ2020050201_smo】
        const currencyCode = getMatchOption(currencyList, 'currencyExchangeRateId', currencyExchangeRateId).currencyCode;

        if (!natureOfContract) {
            message.warning('请选择合同性质');
            return;
        } else {
            if (!relationJdeId) { 
                message.warning('请选择关联JDE');
                return;
            }
            if (sponsorWritable && !sponsorId) {
                message.warning('请选择申办方');
                return;
            }
            if (proCodeWritable && !customerProjectCode) {
                message.warning('请输入项目编号');
                return;
            }

            if (customerWritable && !customerCompanyId) {
                message.warning('请选择客户全名');
                return;
            }
            if (customerWritable && !baUserId) {
                message.warning('请选择BA');
                return;
            }
            if (!contractRelationSite) {
                message.warning('请选择合同关联中心');
                return;
            }
            if (!lineOfBusiness) {
                message.warning('请选择业务线');
                return;
            }
            if (!signingUnit) {
                message.warning('请选择合同签署单位');
                return;
            }
            if (!belongingToUnit) {
                message.warning('请选择收入归属单位');
                return;
            }
            if (!currencyExchangeRateId) {
                message.warning('请选择币种');
                return;
            }
            if (currencyCode !== 'CNY' && !exchangeRate) {
                message.warning('请输入汇率');
                return;
            }
            if (!contractIsSpecifiesAmount) {
                message.warning('请选择合同中是否明标合同金额');
                return;
            }
            if (!(contractAmount || contractAmount === 0)) {
                message.warning('请输入合同额含税');
                return;
            } else {
                if (natureOfContract !== 'SUPPLEMENT_CONTRACT' && contractAmount === 0) {
                    message.warning('合同额含税不支持零');
                    return;
                }
            }
            if (!(taxationFee || taxationFee === 0) || !(rate || rate === 0)) {
                message.warning('请输入合同税率或合同额税费');
                return;
            }
            if (!contractStartDate) {
                message.warning('请选择合同开始时间');
                return;
            }
            if (!contractEndDate) {
                message.warning('请选择合同结束时间');
                return;
            }
            if (!fileList.length) {
                message.warning('请上传附件');
                return;
            }
            let idx = 0;
            for (let i = 0; i < fileList.length; i++) {
                const { response, deletable } = fileList[i];
                if (!response) {
                    message.warning('文件上传中，请稍后！');
                    return;
                }
                if (deletable === false) {
                    continue;
                }
                saveParams[`ids[${idx++}]`] = response.fileMetaId;
            }
        }
        saveParams.contractStartDate = format('date', contractStartDate);
        saveParams.contractEndDate = format('date', contractEndDate);
        
        if (currencyCode === 'CNY') {
            saveParams.initialExpectContractAmount = '';  //预计合同金额（原币）
            saveParams.initialContractAmount = '';  //合同额含税（原币）
            saveParams.initialActualExpenseFee = '';  //实报实销费（原币）
            saveParams.initialActualFee = ''; //实报实销税费(原币)
            saveParams.initialTaxationFee = ''; //税费（原币）
        } else {
            saveParams.initialExpectContractAmount = expectContractAmount;  //预计合同金额（原币）
            saveParams.initialContractAmount = contractAmount;  //合同额含税（原币）
            saveParams.initialActualExpenseFee = actualExpenseFee;  //实报实销费（原币）
            saveParams.initialActualFee = actualFee; //实报实销税费(原币)
            saveParams.initialTaxationFee = taxationFee; //税费（原币）
        }

        const params = {};

        if (currencyCode !== 'CNY') {
            params.expectContractAmount = (expectContractAmount || expectContractAmount === 0) ? (expectContractAmount * exchangeRate).toFixed(2) : '';  //预计合同金额（人民币）
            params.contractAmount = (contractAmount || contractAmount === 0)? (contractAmount * exchangeRate).toFixed(2) : '';  //合同额含税（人民币）
            params.actualExpenseFee = (actualExpenseFee || actualExpenseFee === 0) ? (actualExpenseFee * exchangeRate).toFixed(2) : '';  //实报实销费（人民币）
            params.actualFee =  (actualFee || actualFee === 0) ? (actualFee * exchangeRate).toFixed(2) : ''; //实报实销税费(人民币)
            params.taxationFee = (taxationFee || taxationFee === 0) ? (taxationFee * exchangeRate).toFixed(2) : ''; //税费（人民币）
        }

        this.setState({ loading: true });
        Fetch.post(API_URL.contract.addJdeApply, {
            isCopy: false,
            ...saveParams,
            ...params,
        }).then(res => {
            this.setState({ loading: false }, () => {
                this.hide();
                this.props.loadData();
            });
        }).catch(error => {
            console.log(error);
            this.setState({ loading: false });
        });
    }

    handleChange = (value, key, rateCanEdit = true) => {
        const { saveParams } = this.state;
        switch(key) {
            case 'sponsor': {
                const { value: id, text: name } = value;
                saveParams.sponsorId = id;
                saveParams.sponsorName = name;
                this.setState({ saveParams });
                break;
            }
            case 'customerCompany': {
                const { value: id, text: name, customerCompanyCode } = value;
                saveParams.customerCompanyId = id;
                saveParams.customerCompanyName = name;
                saveParams.customerJdeCode = customerCompanyCode;
                saveParams.customerCompanyBaId = undefined;
                saveParams.baName = undefined;
                saveParams.baCode = undefined;
                this.setState({ saveParams }, () => {
                    this.queryCustomerCompanyBaList();
                });
                break;
            }
            case 'natureOfContract': {
                saveParams[key] = value;
                this.setState({
                    saveParams,
                    fileList: [],
                }, () => {
                    this.handleChange(undefined, 'relationJdeId');
                });
                break;
            }
            
            case 'relationJdeId': {
                saveParams[key] = value;
                const { signingUnitList } = this.props;
                let { customerWritable } = this.state;
                const { relationContractList } = this.state
                const { natureOfContract } = saveParams;
                const {
                    customerProjectCode,
                    customerCompanyId,
                    customerCompanyName,
                    customerJdeCode,
                    customerCompanyBaId,
                    baCode,
                    baName,
                    baUserId,
                    secondLineIds,
                    secondLineNames,
                    unitOfBelongingId,
                    unitOfSigningId,
                    belongingToUnit,
                    isDiscountTermValidity,//是否优惠有效期内
                    isMsaSpecialDiscountCustom,//是否优惠客户
                } = getMatchOption(relationContractList, 'investigationJdeContractId', value);
                const belongingToUnitList = getMatchOption(signingUnitList, 'unitOfSigningId', unitOfSigningId).belongings || [];
                saveParams.customerCompanyId = customerCompanyId || undefined;
                saveParams.customerCompanyName = customerCompanyName || undefined;
                saveParams.customerJdeCode = customerJdeCode || undefined;
                saveParams.customerCompanyBaId = customerJdeCode ? customerCompanyBaId || undefined : undefined;
                saveParams.baCode = baCode || undefined;
                saveParams.baName = baName || undefined;
                saveParams.baUserId = baUserId || undefined;
                saveParams.baUserName = (baName && baUserId)?baName+'['+ baUserId +']':null;

                saveParams.secondLineIds = secondLineIds || undefined;
                saveParams.secondLineNames = secondLineNames || undefined;

                saveParams.signingUnit = unitOfSigningId || undefined;
                saveParams.belongingToUnit = unitOfBelongingId || undefined;
                saveParams.belongingToUnitName = belongingToUnit || undefined;

                const DiscountTermValidity = isDiscountTermValidity || undefined;
                const MsaSpecialDiscountCustom = isMsaSpecialDiscountCustom || undefined;
                this.handleChange(DiscountTermValidity , 'isDiscountTermValidity' );
                this.handleChange(MsaSpecialDiscountCustom , 'isMsaSpecialDiscountCustom' );

                customerWritable = value ? !customerProjectCode : false;

                this.setState({
                    saveParams,
                    customerWritable,
                    belongingToUnitList
                }, () => {
                    this.queryCustomerCompanyBaList();
                });
                break;
            }
            case 'currencyExchangeRateId': {
                saveParams[key] = value;
                const { currencyList } = this.state;
                const { exchangeRate, currencyName } = getMatchOption(currencyList, 'currencyExchangeRateId', value);
                saveParams.exchangeRate = exchangeRate;
                saveParams.currencyExchangeRate = exchangeRate;
                saveParams.currencyName = currencyName;
                saveParams.contractAmount = '';
                saveParams.actualExpenseFee = '';
                saveParams.taxationFee = '';
                saveParams.rate = '';
                saveParams.actualFee = '';
                this.setState({ saveParams });
                break;
            }
            case 'signingUnit': {
                saveParams[key] = value;
                const { signingUnitList } = this.props;
                const belongingToUnitList = getMatchOption(signingUnitList, 'unitOfSigningId', value).belongings || [];

                if (value && !belongingToUnitList.length) {
                    const { signingUnit: prevSigningUnit } = saveParams || {};
                    saveParams.signingUnit = prevSigningUnit;
                    message.warning('收入归属单位不能为空，请联系后台管理员为合同签署单位设置收入归属单位');
                    return;
                }
                if (belongingToUnitList.length === 1) {
                    saveParams.belongingToUnit = belongingToUnitList[0].unitOfBelongingId;
                    saveParams.belongingToUnitName = belongingToUnitList[0].unitOfBelongingName;
                } else {
                    saveParams.belongingToUnit = undefined;
                    saveParams.belongingToUnitName = undefined;
                }
                this.setState({
                    saveParams,
                    belongingToUnitList,
                });
                break;
            }
            case 'customerCompanyBaId': {
                saveParams[key] = value;
                const { baList } = this.state;
                const { employeeCode, userCompellation } = getMatchOption(baList, 'userId', value);
                saveParams.employeeCode = employeeCode;
                saveParams.userCompellation = userCompellation;
                this.setState({ saveParams });
                break;
            }
            case 'baUser': {
                const { value: id, text: name } = value;
                saveParams.baUserId = id;
                saveParams.baUserName = name;
                this.setState({ saveParams });
                break;
            }
            case 'isRealitySettle':
                saveParams.isRealitySettle = value;
                if(value == 1){
                    saveParams.isMsaSpecialContractReduce = null;
                    saveParams.discountContractAmount = null;
                }else if(value == 0){
                    saveParams.isMsaSpecialContractReduce = 0;
                    saveParams.discountContractAmount = null;
                }
                this.setState({ saveParams });
                break;
            case 'isMsaSpecialContractReduce':
                saveParams.isMsaSpecialContractReduce = value;
                if(value == 0 ){
                    saveParams.discountContractAmount = null;
                }
                this.setState({ saveParams });
                break;
            case 'discountContractAmount':
                if(value){
                    if(typeof(value) == typeof('') && value.substring(0,1) === '-'){
                        saveParams.discountContractAmount = value.slice(1);
                    }
                    else{
                        saveParams.discountContractAmount = value
                    }
                }else{
                    saveParams.discountContractAmount = null;
                }
                this.setState({ saveParams });
                break;
            case 'isMsaSpecialDiscountCustom'://是否优惠客户
                saveParams[key] = value;
                if( !value || value == 0 ){
                    saveParams.isMsaSpecialContractReduce = null;
                    saveParams.discountContractAmount = null;
                }
                this.setState({ saveParams });
            break;
            case 'isDiscountTermValidity'://是否优惠有效期
                saveParams[key] = value;
                if(!value || value == 0){
                    saveParams.isMsaSpecialContractReduce = null;
                    saveParams.discountContractAmount = null;
                }else if(value == 1 ){
                    saveParams.isMsaSpecialContractReduce = 0;
                    saveParams.discountContractAmount = null;
                }
                this.setState({ saveParams });
            break;
            case 'rate'://合同税率
                saveParams[key] = value;
                rateCanEdit && this.setState({ saveParams, rateCanEdit: 'rate' });
            break;
            case 'taxationFee'://合同额税费/人民币
                saveParams[key] = value;
                rateCanEdit && this.setState({ saveParams, rateCanEdit: 'rmb' });
            break;
            default: {
                saveParams[key] = value;
                this.setState({ saveParams });
                break;
            }
        }
    }

    handleUploadChange = (file, fileList) => {
        this.setState({ fileList });
    }
    
    handleChangeRateCanEdit = value => {
        this.setState({ rateCanEdit: value })
    }

    getDataList = () => {
        const { signingUnitList } = this.props;
        const {
            saveParams,
            baList,
            fileList,
            currencyList,
            relationContractList,
            belongingToUnitList,
            sponsorWritable,
            proCodeWritable,
            customerWritable,
            rateCanEdit,
        } = this.state;
        const settings = {
            saveParams,
            baList,
            fileList,
            currencyList,
            signingUnitList,
            belongingToUnitList,
            relationContractList,
            sponsorWritable,
            proCodeWritable,
            customerWritable,
            rateCanEdit,
        };
        return (
            <UpdateUI
                {...settings}
                handleChangeRateCanEdit={this.handleChangeRateCanEdit}
                handleChange={this.handleChange}
                handleUploadChange={this.handleUploadChange}
            />
        )
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title="添加JDE建号申请"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="setjde-modal addchildcontract"
                wrapClassName="vertical-center-modal"
                bodyStyle={{ maxHeight: 500 }}
                confirmLoading={loading}
                maskClosable={false}
                width="780px"
            >
                <div className="cont-cont" style={{padding: '0 20px'}}>
                    <Spin spinning={loading}>
                        <ul className="preview-list apply-jde">
                            { this.getDataList() }
                        </ul>
                    </Spin>
                </div>
            </Modal>
        )    
    }
}

export default Update;


// WEBPACK FOOTER //
// ./src/components/contractManagement/terminationApply/Update.js